import { SxProps, Theme } from "@mui/material";

/**
 * Shared `sx` for the mailbox's fixed fields (name, email, subject, message).
 *
 * These sit directly above the structured (RJSF) fields, which render inside
 * `FormThemeProvider` with a medium input weight. Matching that weight here
 * keeps the two blocks visually identical without restyling inputs elsewhere
 * in the app (the mailbox-group search bar, the password-protected transfer
 * dialog), which an app-theme-level override would.
 */
export const fixedFieldSx: SxProps<Theme> = {
  "& .MuiInputBase-input": { fontWeight: 500 },
};
